module.exports = __webpack_public_path__ + "img/typewriter-goals.dcf6250.jpg";